module.exports = __webpack_public_path__ + "static/media/main.4bbd1200.png";